import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col } from 'reactstrap';
import moment from 'moment';
import { interval } from 'rxjs';

let subscribe;
const ThemeOneFooter: React.FC = () => {

    const { t } = useTranslation("translations");
    const loginTime = `${moment().format('DD-MM-YYYY')} ${moment().format('LT')}`;
    const difference = 60 - new Date().getSeconds();
    const [time, setTime] = useState(loginTime);

    useEffect(() => {
        subscribe = interval(1000 * difference).subscribe(() => {
            setTime(`${moment().format('DD-MM-YYYY')} ${moment().format('LT')}`);
        })
        return () => {
            if (subscribe)
                subscribe.unsubscribe();
        }
    })

    return (
        <>
            <div className="smdbFooter">
                <Row className="align-center">
                    <Col>
                        <span>{t('DisplayBoard.footerTitle')}</span>
                    </Col>
                    <Col className="text-right">
                        <span>{t('DisplayBoard.footerTitleArb')}</span>
                    </Col>
                </Row>
                <Row className='smcopyright'>
                    <Col><span>{t('DisplayBoard.powerby')}</span> {t('DisplayBoard.vectramind')}</Col>
                    <Col>{time}</Col>
                </Row>
            </div>
        </>
    )
}
export default React.memo(ThemeOneFooter);